module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_page_link":"Edit page link","custom_link":"Custom link","custom_link_desc":"The page URL will appear as below"},"id":{"edit_page_link":"Edit halaman link","custom_link":"link khusus","custom_link_desc":"URL halaman ini akan muncul seperti di bawah"}}')
  delete Component.options._Ctor
}
